module.exports = __webpack_public_path__ + "img/turisme_rekreasjon_med_paavirkningsgrad.28435582.jpg";